export default function getFileName(headers): string {
  let fileName = '';
  const contentDisposition = headers?.['content-disposition'];
  if (contentDisposition) {
    const regexMatch = contentDisposition.match(/.*filename="(.*)"/);
    if (regexMatch && regexMatch.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      fileName = decodeURI(regexMatch[1]);
    }
  }
  return fileName;
}
